import Vue from 'vue'
import VueI18n, { LocaleMessages } from 'vue-i18n'
import { localeMap } from './config'
import fr from 'vuetify/src/locale/fr'
import en from 'vuetify/src/locale/en'

Vue.use(VueI18n)

const vuetifyMessages = {
  fr: {
    $vuetify: { ...fr }
  },
  en: {
    $vuetify: { ...en }
  }
}

function loadLocaleMessages (): LocaleMessages {
  const locales = require.context('../../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages: LocaleMessages = {}

  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)

    if (matched && matched.length > 1) {
      const locale = matched[1]
      const localeMessages = locales(key)

      messages[locale] = {
        ...(vuetifyMessages[locale] || {}),
        ...localeMessages
      }
    }
  })

  Object.keys(vuetifyMessages).forEach((locale) => {
    if (!messages[locale]) {
      messages[locale] = { ...vuetifyMessages[locale] }
    }
  })

  return messages
}

function getLocale (): string {
  return localeMap.get(window.location.hostname) || 'fr'
}

const plugin = new VueI18n({
  locale: getLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'fr',
  silentFallbackWarn: false,
  silentTranslationWarn: true,
  messages: loadLocaleMessages()
})

export default plugin
